import styled, { css } from 'styled-components';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
import { getRadius } from '../../../foundation/theme/shape.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { DROPDOWN_PADDING_SIZES } from './Dropdown.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const DropdownButton = styled.button `
  ${({ mode, schema, size, theme, variant }) => {
    const { default: color, disabled, focus, hover } = getSchemaVariant({
        mode,
        schema,
        theme,
        variant
    });
    return css `
      // Display & Box model.
      align-items: center;
      border-radius: ${getRadius(theme, 'm')};
      display: inline-flex;
      gap: ${getSpace('s')};
      justify-content: center;
      padding-bottom: ${getSpace(DROPDOWN_PADDING_SIZES[size].vertical)};
      padding-left: ${getSpace(DROPDOWN_PADDING_SIZES[size].horizontal)};
      padding-right: ${getSpace(DROPDOWN_PADDING_SIZES[size].horizontal)};
      padding-top: ${getSpace(DROPDOWN_PADDING_SIZES[size].vertical)};

      // Colors.
      background-color: ${color.background};
      border: 2px solid ${color.border};
      color: ${color.foreground};

      svg {
        color: ${color.foregroundAlt};
        max-height: 16px;
      }

      .closed,
      .opened {
        transition: 0.175s;
      }

      .opened {
        transform: rotate(180deg);
      }

      // Other.
      cursor: pointer;
      transition: 0.3s;

      /* Status: Disabled. */
      &:disabled {
        background-color: ${disabled.background};
        border: 2px solid ${disabled.border};
        color: ${disabled.foreground};
        cursor: not-allowed;

        svg {
          color: ${disabled.foregroundAlt};
        }
      }

      /* Status: Focus. */
      &:focus {
        background-color: ${focus.background};
        border: 2px solid ${focus.border};
        color: ${focus.foreground};

        svg {
          color: ${focus.foregroundAlt};
        }
      }

      /* Status: Hover. */
      &:hover {
        background-color: ${hover.background};
        border: 2px solid ${hover.border};
        color: ${hover.foreground};

        svg {
          color: ${hover.foregroundAlt};
        }
      }
    `;
}}
`;
export const DropdownButtonLabel = styled.div `
  // Display & Box model.
  align-items: center;
  display: flex;
  gap: ${getSpace('s')};
  margin-right: ${({ iconOnly }) => (iconOnly ? 0 : getSpace('m'))};
`;
export const DropdownOptionAsButton = styled.button `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return css `
      // Box model.
      align-items: center;
      border: none;
      display: flex;

      // Colors.
      background-color: ${color.background};
      color: ${color.foreground};

      svg {
        color: ${color.foreground};
      }

      // Space.
      cursor: pointer;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      &:hover {
        background-color: ${tokens.colors.active[100].value};
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
export const DropdownOptionAsLink = styled.a `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return css `
      // Display & Box model.
      align-items: center;
      border: none;
      display: flex;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      // Colors.
      background-color: transparent;
      color: ${color.foreground};

      // Other.
      cursor: pointer;
      text-decoration: none;

      svg {
        color: ${color.foreground};
      }

      &:hover {
        background-color: ${tokens.colors.active[100].value};
        color: ${tokens.colors.navy[800].value};
      }

      &:visited,
      &:active,
      &:focus {
        color: inherit;
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
export const DropdownOptionSpin = styled.div `
  // Display & Box.
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1px 0;
  width: 100%;
`;
export const DropdownOptionLinkSpin = styled.div `
  // Display & Box.
  align-items: center;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Other.
  cursor: pointer;

  &:hover {
    background-color: ${tokens.colors.active[100].value};
    color: ${tokens.colors.navy[800].value};
  }
`;
export const DropdownOptionsWrapper = styled.div `
  ${({ position, size, theme }) => {
    return css `
      // Positioning.
      position: absolute;
      // top: 64px;
      top: ${size === 's' ? '64px' : '54px'};
      z-index: 10;

      ${position === 'left' && 'left: 0;'}
      ${position === 'right' && 'right: 0;'}

      // Display & Box model.
      border-radius: ${getRadius(theme, 'm')};
      display: flex;
      flex-direction: column;
      max-height: 300px;
      overflow: auto;
      padding: ${getSpace('s')};
      white-space: nowrap;
      width: fit-content;

      // Color.
      background-color: ${tokens.colors.white[100].value};
      border: 2px solid ${tokens.colors.midnight[200].value};
    `;
}}
`;
export const DropdownRoot = styled.div `
  // Positioning.
  position: relative;
  width: fit-content;

  // Display & Box model.
  display: flex;
  flex-direction: column;
  gap: ${getSpace('2xs')};
`;
//# sourceMappingURL=Dropdown.styles.js.map